import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { req_edit_cslc_myparticipant } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { Card, message, Typography } from "antd";
//import FilePng from "./file-png";
import FilePdf from "./file-pdf";
import { API_BASE } from "../../utils/contrains";

const { Link } = Typography;

class MyParticipantFileAEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    participant: PropTypes.object,
    fileTarget: PropTypes.string,
  };

  state = {
    item: {
      Uid: "",
      //AttachedfileA: "",
      //AttachedfileB: "",
      AttachedfileC: "",
      condition: "",
    },
  };

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.init();
  }

  constructor(props) {
    super(props);

    this.get_png_file = React.createRef();
    this.get_pdf_file = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_edit_item = async (item) => {
    item.condition = this.props.fileTarget;
    const result = await req_edit_cslc_myparticipant(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success("上傳成功");
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  init = () => {
    if (this.props.participant) {
      const item = this.props.participant;
      this.setState({ item });
    }
  };

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const errors = [];

    const row = this.state.item;
    const pdf_file =
      this.get_pdf_file.current.output_files() === undefined
        ? ""
        : this.get_pdf_file.current.output_files();

    row.AttachedfileC = pdf_file === "" ? "" : pdf_file.url;

    if (errors.length === 0) {
      console.log(row);
      this.api_edit_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    const { Uid, AttachedfileC } = this.state.item;
    //console.log(this.props.participant);
    const pdffileUrlPath = "/api/UploadFile/AddInsideContestFile";
    const copyrightPdfFile =
      API_BASE + "/Templates/CopyrightAuthorizationAgreement.pdf";
    const pdfFile =
      AttachedfileC === ""
        ? []
        : [
            {
              Uid: Uid,
              FileNewName: "著作權切結書",
              FileUrl: AttachedfileC,
            },
          ];
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>
                <span className="text-danger">*</span>切結書(
                <span style={{ color: "blue" }}>PDF格式</span>)
              </label>
              <FilePdf
                ref={this.get_pdf_file}
                data_source={pdfFile}
                api_url={pdffileUrlPath}
              ></FilePdf>
              <p>
                <Link
                  href={copyrightPdfFile}
                  target="_blank"
                  download={"授權書"}
                >
                  授權書格式下載
                </Link>
              </p>
            </div>
          </div>
          <div className="form-row">
            <input
              type="submit"
              value="送出"
              className="btn btn-primary btn-sm btn-block"
            />
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyParticipantFileAEditModal);
